import { createBrowserHistory } from 'history'
// import {appRootPath} from '../config'

export const history = createBrowserHistory({})
